module.exports = __webpack_public_path__ + "static/media/workorders2.319b9c54.png";